import { createSlice, PayloadAction, SliceCaseReducers } from '@reduxjs/toolkit';
import { ICauHinhHeThong } from 'src/types/CauHinhHeThong.type';

const cauHinhHeThongSlice = createSlice<ICauHinhHeThong[], SliceCaseReducers<ICauHinhHeThong[]>>({
  name: 'CauHinhHeThong',
  initialState: [],
  reducers: {
    setCauHinhHeThong: (state, { payload }: PayloadAction<ICauHinhHeThong[]>) => {
      return payload;
    },
  },
});

export const { setCauHinhHeThong } = cauHinhHeThongSlice.actions;

export default cauHinhHeThongSlice.reducer;
